import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Explicit approval: pilot tenants, typed phrase, short expiry, per-cycle cap. In DEV it is only a rehearsal (nothing can be sent).
export function ActivationApproveForm({ phrase, pilot, onDone }) {
  const api = useApi();
  const [tenants, setTenants] = useState(pilot?.id || "");
  const [confirm, setConfirm] = useState("");
  const [days, setDays] = useState(7);
  const [cap, setCap] = useState(10);
  const [busy, setBusy] = useState(false);
  const list = tenants.split(/[\s,]+/).filter(Boolean);
  const call = async (path, body, msg) => {
    setBusy(true);
    try { const { data } = await api.post(path, body); toast.success(msg); onDone(data); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <section className="space-y-3 rounded-lg border border-slate-200 bg-white p-4" data-testid="activation-approve-form">
      <h2 className="text-base font-semibold text-slate-900">Prova o approva l'attivazione</h2>
      <label className="block text-sm text-slate-700">Clienti pilota (ID separati da virgola, max 10)
        <Input value={tenants} onChange={(e) => setTenants(e.target.value)} placeholder="cli_…" className="mt-1" data-testid="activation-tenants" /></label>
      <div className="flex flex-wrap gap-3">
        <label className="text-sm text-slate-700">Durata (giorni, max 14 in pilota, 365 in generale)<Input type="number" min={1} max={365} value={days} onChange={(e) => setDays(Number(e.target.value))} className="mt-1 w-28" data-testid="activation-days" /></label>
        <label className="text-sm text-slate-700">Max email per ciclo<Input type="number" min={1} max={50} value={cap} onChange={(e) => setCap(Number(e.target.value))} className="mt-1 w-28" data-testid="activation-cap" /></label>
      </div>
      <label className="block text-sm text-slate-700">Per approvare scrivi: <span className="font-mono font-semibold">{phrase}</span>
        <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" data-testid="activation-confirm" /></label>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" disabled={busy || !list.length} onClick={() => call("/admin/email-activation/dry-run", { tenants: list }, "Prova eseguita: nessuno stato cambiato")} data-testid="activation-dry-run">Prova (dry-run)</Button>
        <Button disabled={busy || !list.length || confirm.trim() !== phrase} onClick={() => call("/admin/email-activation/approve", { tenants: list, confirm, days, max_per_cycle: cap }, "Approvazione registrata")} data-testid="activation-approve">Approva</Button>
      </div>
      <p className="text-xs text-slate-500">Le email create prima dell'approvazione non partono mai. Senza interruttore, provider, mittente e adapter collegati nessuna email può uscire.</p>
    </section>
  );
}
